export default function setStickyFooter() {
    let footer = document.getElementById('footer');
    let app = document.getElementById('content');
    if (app.offsetHeight + footer.offsetHeight  <= window.innerHeight) {
        app.style.minHeight = window.innerHeight  - footer.offsetHeight + 'px';
    } else {
        app.style.minHeight = 'auto';
    }
}



/** WEBPACK FOOTER **
 ** ./src/utils/stickyFooter.js
 **/